import React, { useState } from "react";
import { Link } from "react-router-dom";

//css
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo, faTrash } from "@fortawesome/free-solid-svg-icons";

//pages
import AddSstTeam from "./AddSstTeam.js";
import EditSstTeam from "./EditSstTeam.js";
import AppNav from "../../header/AppNav";
// import AppPagination from "../components/Pagination";
// import EditSstTeam from "./EditSstTeam.js";

function SstTeam() {
  const [addModalShow, setAddModalShow] = useState(false);

  const getSstTeam = async () =>
    // page = 1
    {
      // setLoading(true);
      // try {
      //   const res = await BedTypeServices.getAllBedTypes(page);
      //   if (res.data?.length > 0) {
      //     setBedType(res.data);
      //     setPagination({
      //       cur: res.pagination_data.page,
      //       max: res.pagination_data.pages,
      //     });
      //   } else {
      //     setBedType([]);
      //     setPagination({
      //       cur: 1,
      //       max: 1,
      //     });
      //   }
      //   setLoading(false);
      // } catch (error) {
      //   alert(error.message);
      //   setLoading(false);
      // }
      console.log("Hi");
    };

  return (
    <div>
      <AppNav />
      <h1 className="list-style">Secondary Screening Members</h1>
      <div className="list-table-style">
        <div className="add-button">
          <Button onClick={() => setAddModalShow(true)}>Create Team</Button>
          <AddSstTeam
            show={addModalShow}
            onHide={() => setAddModalShow(false)}
            // onClose={() => getSstTeam()}
          />
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Sl no</th>
              <th className="list-item-align-center">Team Name</th>
              <th className="list-item-align-center">Team Members</th>
              <th className="list-item-align-center">Edit</th>
              <th className="list-item-align-center">Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td className="list-item-align-center">Team 1</td>
              <td className="list-item-align-center">
                Nikitha
                <br />
                Sphoorthi
                <br />
                Smrithi
              </td>
              <td className="list-item-align-center">
                <EditSstTeam
                  // sstTeam={i}
                  onClose={() => getSstTeam()}
                />
              </td>
              <td className="list-item-align-center">
                <FontAwesomeIcon icon={faTrash} size="lg" style={{ color: '#05275a' }} />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      {/* <div className="d-flex justify-content-center my-3">
        <AppPagination
          curPage={pagination.cur}
          maxPage={pagination.max}
          changePage={changePage}
        />
      </div> */}
    </div>
  );
}

export default SstTeam;
